import {
  VOUCHER_CHECKOUT_RESET,
	VOUCHER_CHECKOUT_DECLINED,
	VOUCHER_CHECKOUT_SUCCESS,
	VOUCHER_CHECKOUT_FAILED,
	VOUCHER_CHECKOUT_PENDING,
	VOUCHER_CHECKOUT_OPERATION_NOT_PERMITTED,
	VOUCHER_CHECKOUT_TRANSACTION_LIMIT_OVER,
	VOUCHER_CHECKOUT_NOT_SUFFICIENT_LIMIT,
	VOUCHER_CHECKOUT_TRANSACTION_LIMIT_EXCEEDED,
	VOUCHER_CHECKOUT_LOADING
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  pending: false,
  success: false,
  declined: false,
  operationNotPermitted: false,
  transactionLimitOver: false,
  notSufficientLimit: false,
  transactionLimitExceeded: false,
  data: {},
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VOUCHER_CHECKOUT_LOADING:
      return {
        ...state,
        isLoading: true,
        success: false,
        pending: false,
        failed: true,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };
    case VOUCHER_CHECKOUT_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: false,
        failed: true,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };
    case VOUCHER_CHECKOUT_PENDING:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: true,
        failed: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };
    case VOUCHER_CHECKOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_DECLINED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: true,
        pending: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: true,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_TRANSACTION_LIMIT_OVER:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: true,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_NOT_SUFFICIENT_LIMIT:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: true,
        transactionLimitExceeded: false,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_TRANSACTION_LIMIT_EXCEEDED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: true,
        data: action.payload,
        networkError: ""
      };

    case VOUCHER_CHECKOUT_RESET:
      return (state = initialState);

    default:
      return state;
  }
};